
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetomahabaleshwer() {



    const cardData =
    {
        keyword: 'Pune to Mahabaleshwar Cabs',
        heading: 'Mauli Cabs: Pune to Mahabaleshwar Cabs',
        headingDescription: 'Mauli Cabs offers reliable and comfortable Pune to Mahabaleshwar cabs, ensuring a smooth and scenic journey to the beautiful hill station of Mahabaleshwar. Whether you’re visiting for a relaxing vacation, exploring nature trails, or enjoying the local attractions, we provide a variety of vehicles including sedans, SUVs, and premium cars to suit your needs. With professional drivers, transparent pricing, no hidden charges, and a commitment to customer satisfaction, Mauli Cabs guarantees a hassle-free and enjoyable ride from Pune to Mahabaleshwar.',

        top: 'Top Places to Visit in Mahabaleshwar with Mauli Cabs',

"topPlaces": [
    {
        "title": "Venna Lake",
        "description": "Venna Lake is one of the most popular attractions in Mahabaleshwar, offering boating and a serene atmosphere surrounded by lush greenery. The lake is perfect for a peaceful getaway with family or friends."
    },
    {
        "title": "Arthur's Seat",
        "description": "Arthur's Seat is one of the most stunning viewpoints in Mahabaleshwar, offering a panoramic view of the surrounding valleys and the dense forests. It's especially known for its breathtaking sunrise and sunset views."
    },
    {
        "title": "Pratapgad Fort",
        "description": "Situated around 24 km from Mahabaleshwar, Pratapgad Fort is a historic fort built by Shivaji Maharaj. The fort offers incredible views of the surrounding landscape and holds significant historical importance."
    },
    {
        "title": "Mapro Garden",
        "description": "Mapro Garden is a famous spot in Mahabaleshwar known for its strawberry products, including jams, syrups, and desserts. It also offers a café with delicious snacks and a beautiful garden to relax in."
    },
    {
        "title": "Elephant's Head Point",
        "description": "This viewpoint is named for its striking rock formation, which resembles an elephant’s head. It offers magnificent views of the surrounding valleys and is a great spot for photography."
    },
    {
        "title": "Lingmala Waterfall",
        "description": "Lingmala Waterfall, located on the Mahabaleshwar-Pune road, is a beautiful waterfall that offers a refreshing sight. The waterfall is a favorite among nature lovers and photographers."
    },
    {
        "title": "Wilson Point",
        "description": "Wilson Point is the highest point in Mahabaleshwar, offering panoramic views of the surrounding hills, valleys, and the town itself. It's a perfect spot for sunrise views and a peaceful experience."
    },
    {
        "title": "Rajpuri Caves",
        "description": "The Rajpuri Caves, located about 10 km from Mahabaleshwar, are ancient caves surrounded by lakes. They are believed to have been used by the Pandavas during their exile and are a popular historical attraction."
    },
    {
        "title": "Babington Point",
        "description": "Babington Point is another viewpoint in Mahabaleshwar that provides mesmerizing views of the valleys and nearby hills. The place is named after the famous British official, Sir Babington."
    },
    {
        "title": "Chinaman’s Waterfall",
        "description": "Chinaman’s Waterfall is a scenic spot located about 2 km from the main market. It's a lovely place to enjoy the beauty of nature and offers a calm environment for relaxation."
    }
],

"services": [
    {
      "name": "Pune to Mahabaleshwar Cab Booking",
      "description": "Book a comfortable and reliable cab for your journey from Pune to Mahabaleshwar. Travel in style and comfort with our professional drivers."
    },
    {
      "name": "Taxi from Pune to Mahabaleshwar",
      "description": "Get a taxi from Pune to Mahabaleshwar for a hassle-free and comfortable ride. Our taxis are available for both one-way and round-trip services."
    },
    {
      "name": "Pune to Mahabaleshwar Car Hire",
      "description": "Rent a car for your trip from Pune to Mahabaleshwar. Choose from a wide range of vehicles and enjoy a stress-free journey."
    },
    {
      "name": "Pune to Mahabaleshwar Taxi Service",
      "description": "Book a reliable taxi service for your Pune to Mahabaleshwar trip. We ensure timely pick-ups, comfortable rides, and safe travel."
    },
    {
      "name": "Pune to Mahabaleshwar Cab Rental",
      "description": "Rent a cab for your journey from Pune to Mahabaleshwar. Enjoy the flexibility of choosing the best vehicle for your trip."
    },
    {
      "name": "Pune to Mahabaleshwar Elphinstone Point Car",
      "description": "Take a scenic drive from Pune to Mahabaleshwar's Elphinstone Point in a comfortable car. Enjoy breathtaking views on the way."
    },
    {
      "name": "Pune to Mahabaleshwar Pratapgad Fort Car",
      "description": "Visit the historic Pratapgad Fort with a car rental service from Pune to Mahabaleshwar. A comfortable and convenient ride to this iconic location."
    },
    {
      "name": "Pune to Mahabaleshwar Cab Price",
      "description": "Check out the competitive cab prices for your journey from Pune to Mahabaleshwar. Get a clear breakdown of fares based on vehicle type and distance."
    },
    {
      "name": "Pune to Mahabaleshwar 2 Days Taxi Fare",
      "description": "Plan a 2-day trip to Mahabaleshwar with our special taxi fare package. Get comfortable rides and explore the best attractions in Mahabaleshwar."
    },
    {
      "name": "Book Cab from Pune to Mahabaleshwar",
      "description": "Book your cab from Pune to Mahabaleshwar online with ease. Our platform provides reliable booking services for a seamless travel experience."
    },
    {
      "name": "Pune to Mahabaleshwar Cabs",
      "description": "Book a cab from Pune to Mahabaleshwar for a comfortable and relaxing journey. Our cab services cater to both solo and group travelers."
    },
    {
      "name": "Pune to Mahabaleshwar Taxi",
      "description": "Travel in comfort with our Pune to Mahabaleshwar taxi services. Whether you're planning a short or long trip, we have you covered."
    },
    {
      "name": "Pune to Mahabaleshwar Cab Price",
      "description": "Get the best cab prices for your trip from Pune to Mahabaleshwar. Compare fares and book the most cost-effective option."
    },
    {
      "name": "Pune to Mahabaleshwar Distance by Taxi Fare",
      "description": "Check the estimated fare for your trip from Pune to Mahabaleshwar based on distance and vehicle type. Get accurate pricing before you book."
    },
    {
      "name": "Pune to Mahabaleshwar Cab for 2 Days",
      "description": "Book a cab for a 2-day trip to Mahabaleshwar. Explore the hill station at your own pace with flexible itinerary options."
    },
    {
      "name": "Pune to Mahabaleshwar Car Package",
      "description": "Book a car package for your trip from Pune to Mahabaleshwar. This all-inclusive package covers your transportation, sightseeing, and accommodation needs."
    },
    {
      "name": "Pune to Mahabaleshwar Cab Service",
      "description": "Get a premium cab service for your trip from Pune to Mahabaleshwar. Our drivers are well-trained and the cars are comfortable and safe."
    },
    {
      "name": "Cab for Mahabaleshwar from Pune",
      "description": "Book a comfortable cab from Pune to Mahabaleshwar for a relaxing journey. Our services include door-to-door pick-up and drop-off."
    },
    {
      "name": "Pune to Mahabaleshwar Car Rental",
      "description": "Rent a car for your journey from Pune to Mahabaleshwar. Choose from a variety of options based on your preferences and enjoy a flexible travel experience."
    },
    {
      "name": "Cab Service from Pune to Mahabaleshwar",
      "description": "Book a cab service for your trip from Pune to Mahabaleshwar. Enjoy a comfortable and safe ride with professional drivers."
    },
    {
      "name": "Pune to Mahabaleshwar Cab Charges",
      "description": "Check the charges for a cab from Pune to Mahabaleshwar. We offer transparent pricing with no hidden charges."
    },
    {
      "name": "Taxi Service from Pune to Mahabaleshwar",
      "description": "Book a taxi service for a quick, safe, and reliable ride from Pune to Mahabaleshwar. We ensure a smooth and enjoyable journey."
    },
    {
      "name": "Taxi for Mahabaleshwar from Pune",
      "description": "Book a taxi for Mahabaleshwar from Pune. Our taxis are equipped with modern amenities to ensure a comfortable trip."
    },
    {
      "name": "Pune to Tapola Cab",
      "description": "Book a cab from Pune to Tapola for a scenic drive and peaceful getaway. Our taxi service ensures comfort and timely arrivals."
    },
    {
      "name": "Pune to Mahabaleshwar Tempo Traveller",
      "description": "Travel with a group in a Tempo Traveller from Pune to Mahabaleshwar. Our spacious and comfortable vehicles are perfect for group trips."
    },
    {
      "name": "Pune to Mahabaleshwar Taxi Drop",
      "description": "Get a one-way taxi drop from Pune to Mahabaleshwar. Enjoy a smooth and direct ride to your destination."
    },
    {
      "name": "Pune to Mahabaleshwar Cab Cost",
      "description": "Check the cab cost from Pune to Mahabaleshwar. We offer competitive pricing and ensure a cost-effective trip for all our customers."
    },
    {
      "name": "Pune Airport to Mahabaleshwar Cabs",
      "description": "Book a cab from Pune Airport to Mahabaleshwar for a seamless transfer. Our drivers will pick you up from the airport and drop you at your destination."
    }
  ],
  "tableData": [
    ["Pune to Mahabaleshwar Cab Booking", "Taxi from Pune to Mahabaleshwar"],
    ["Pune to Mahabaleshwar Car Hire", "Pune to Mahabaleshwar Taxi Service"],
    ["Pune to Mahabaleshwar Cab Rental", "Pune to Mahabaleshwar Elphinstone Point Car"],
    ["Pune to Mahabaleshwar Pratapgad Fort Car", "Pune to Mahabaleshwar Cab Price"],
    ["Pune to Mahabaleshwar 2 Days Taxi Fare", "Book Cab from Pune to Mahabaleshwar"],
    ["Pune to Mahabaleshwar Cabs", "Pune to Mahabaleshwar Taxi"],
    ["Pune to Mahabaleshwar Cab Price", "Pune to Mahabaleshwar Distance by Taxi Fare"],
    ["Pune to Mahabaleshwar Cab for 2 Days", "Pune to Mahabaleshwar Car Package"],
    ["Pune to Mahabaleshwar Cab Service", "Cab for Mahabaleshwar from Pune"],
    ["Pune to Mahabaleshwar Car Rental", "Cab Service from Pune to Mahabaleshwar"],
    ["Pune to Mahabaleshwar Cab Charges", "Taxi Service from Pune to Mahabaleshwar"],
    ["Taxi for Mahabaleshwar from Pune", "Pune to Tapola Cab"],
    ["Pune to Mahabaleshwar Tempo Traveller", "Pune to Mahabaleshwar Taxi Drop"],
    ["Pune to Mahabaleshwar Cab Cost", "Pune Airport to Mahabaleshwar Cabs"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs offers reliable and timely service for your Pune to Mahabaleshwar cab journey. Whether you're heading to Mahabaleshwar for a relaxing vacation or an important trip, our drivers ensure punctual pickups and drop-offs, making your travel experience smooth and stress-free."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your Pune to Mahabaleshwar trip, we offer a range of comfortable and spacious vehicles, including sedans, SUVs, and premium cars. All vehicles are air-conditioned and well-maintained, providing a comfortable and enjoyable ride through the scenic route."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are well-acquainted with the Pune to Mahabaleshwar route. They ensure a safe and smooth journey, navigating the best roads and avoiding traffic, so you can relax and enjoy the beautiful landscapes along the way."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers competitive and transparent pricing for your Pune to Mahabaleshwar cab booking. We provide clear pricing with no hidden charges, so you can enjoy your trip without worrying about unexpected costs."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our priority. All our vehicles are regularly maintained and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure a secure and comfortable journey."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Mahabaleshwar cab ride. Whether you need an early morning ride or a late-night return, our customer service team is always ready to assist you with booking your cab at any time."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Mahabaleshwar cab with Mauli Cabs is quick and hassle-free. You can book your ride online via our website or mobile app, or contact our customer service team for personalized assistance to ensure a smooth booking experience."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Mahabaleshwar journey. Whether you're planning a family trip, a romantic getaway, or a sightseeing tour, we can tailor the service to suit your preferences and make your trip special."
    }
]















    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Mahabaleshwar with Mauli Cabs?',
            answer: 'Booking a cab from Pune to Mahabaleshwar with Mauli Cabs is simple! You can book directly through our website or mobile app by entering your pickup location (Pune) and destination (Mahabaleshwar), selecting the vehicle you prefer, and confirming the booking. Alternatively, you can contact our customer support for assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Mahabaleshwar trip?',
            answer: 'Mauli Cabs offers a variety of vehicles for the Pune to Mahabaleshwar route, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. Whether you are traveling solo or in a group, we have the perfect vehicle for your journey.',
        },
        {
            question: 'Is the fare for the Pune to Mahabaleshwar trip fixed?',
            answer: 'Yes, the fare for the Pune to Mahabaleshwar trip is fixed and transparent. The fare includes tolls, taxes, and driver charges, with no hidden costs. You will know the total fare upfront before you confirm your booking.',
        },
        {
            question: 'Can I book a round trip from Pune to Mahabaleshwar?',
            answer: 'Yes, you can easily book a round trip from Pune to Mahabaleshwar. Simply provide your return details while making the booking, and we will ensure that your ride is seamless, both ways.',
        },
        {
            question: 'How long does the journey from Pune to Mahabaleshwar take?',
            answer: 'The journey from Pune to Mahabaleshwar typically takes around 3 to 4 hours, depending on traffic and road conditions. Our experienced drivers will ensure that you enjoy a comfortable and timely ride.',
        },
        {
            question: 'Are the drivers experienced for the Pune to Mahabaleshwar route?',
            answer: 'Yes, all Mauli Cabs drivers are professional, experienced, and familiar with the best routes from Pune to Mahabaleshwar. They prioritize your safety, comfort, and timely arrival.',
        },
        {
            question: 'Can I make stops during my journey from Pune to Mahabaleshwar?',
            answer: 'Yes, you can make stops along the way for breaks, sightseeing, or photo opportunities. Our drivers are happy to accommodate your requests and make your journey more enjoyable.',
        },
        {
            question: 'Are the cabs air-conditioned and well-maintained for the Pune to Mahabaleshwar trip?',
            answer: 'Yes, all our cabs are air-conditioned and regularly maintained to ensure comfort and cleanliness. We ensure that your ride is smooth, pleasant, and comfortable throughout the journey.',
        },
        {
            question: 'Can I cancel or modify my booking for the Pune to Mahabaleshwar trip?',
            answer: 'Yes, you can easily cancel or modify your booking for the Pune to Mahabaleshwar trip. We offer a flexible cancellation and modification policy through our website or app, and our customer support team is always ready to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Mahabaleshwar trip?',
            answer: 'Mauli Cabs offers competitive pricing, a wide range of vehicles, professional drivers, and a commitment to punctuality. Whether you’re traveling for leisure or business, we ensure a comfortable, safe, and enjoyable journey from Pune to Mahabaleshwar.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Suresh Joshi",
            position: "Corporate Executive",
            text: "I recently traveled from Pune to Mahabaleshwar with Mauli Cabs, and the experience was fantastic. The vehicle was clean and comfortable, the driver was professional, and the entire trip was hassle-free. I highly recommend Mauli Cabs for any long-distance travel.",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Priya Deshmukh",
            position: "Tourist",
            text: "My trip to Mahabaleshwar from Pune was made incredibly smooth by Mauli Cabs. The driver was friendly and knowledgeable about the best routes, and the car was in great condition. It was a stress-free and enjoyable ride. I’ll definitely use Mauli Cabs again for future trips!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Mahabaleshwar Cabs Booking by Mauli Cabs",
        "description": "Mauli Cabs offers comfortable and reliable taxi services from Pune to Mahabaleshwar, including one-way, round-trip, and multi-day options. Enjoy sightseeing tours to popular spots like Elphinstone Point and Pratapgad Fort with affordable pricing and 24x7 online booking support.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "4100"
        }
      };
      
      

    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune to Mahabaleshwar Cabs | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Mahabaleshwar cab with Mauli Cabs. Choose from affordable taxi services for one-way or round-trip travel. Visit iconic spots like Elphinstone Point and Pratapgad Fort with our reliable and comfortable ride options."
        />
        <meta
          name="keywords"
          content="Pune to Mahabaleshwar Cab Booking, Taxi from Pune to Mahabaleshwar, Pune to Mahabaleshwar Car Hire, Pune to Mahabaleshwar Taxi Service, Pune to Mahabaleshwar Cab Rental, Pune to Mahabaleshwar Elphinstone Point Car, Pune to Mahabaleshwar Pratapgad Fort Car, Pune to Mahabaleshwar Cab Price, Pune to Mahabaleshwar 2 Days Taxi Fare, Book Cab from Pune to Mahabaleshwar, Pune to Mahabaleshwar Cabs, Pune to Mahabaleshwar Taxi, Pune to Mahabaleshwar Cab Price, Pune to Mahabaleshwar Distance by Taxi Fare, Pune to Mahabaleshwar Cab for 2 Days, Pune to Mahabaleshwar Car Package, Pune to Mahabaleshwar Cab Service"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      



            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/36.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomahabaleshwer;